import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9b2eb4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification w-100 my-auto" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = {
  key: 0,
  class: "notification-detail mt-2"
}

import Toast from "primevue/toast";

type Severity = "success" | "info" | "warn" | "error";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const icons: Record<Severity, string> = {
    success: "fas fa-check-circle fa-lg",
    info: "fas fa-info-circle fa-lg",
    warn: "fas fa-exclamation-triangle fa-lg",
    error: "fas fa-exclamation-circle fa-lg"
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Toast), null, {
    message: _withCtx(({ message }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("i", {
          class: _normalizeClass(icons[message.severity as Severity])
        }, null, 2),
        _createElementVNode("h4", _hoisted_2, _toDisplayString(message.summary), 1),
        (message.detail)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(message.detail), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})